// extracted by mini-css-extract-plugin
export default {"melodyVideo":"QI-z","isFullWidth":"RI-z","landingPageVideo":"SI-z","play":"TI-z","iframeVideo":"UI-z","playHidden":"VI-z","fullwidth":"WI-z"};